import styled from 'styled-components';
import { COLOR_RED } from '../../../assets/styles/colors';

export default styled.div`
  .react-datepicker-wrapper {
    width: 100%;
    input {
      border-radius: 2px;
      min-width: 100%;
      width: 100%;
      padding: 12px 15px;
      border: 1px solid rgba(63, 61, 86, 0.4);
      background-color: #ffffff;
      font-size: 18px;
      line-height: 24px;
      border-radius: 12px;
      -webkit-appearance: none;

      &:focus,
      &:hover {
        border: 1px solid #000000;
        outline: none;
        box-shadow: none;
        border-color: #000000;
      }

      &::placeholder {
        color: #3f3d56;
        opacity: 0.5;
        font-weight: 600;
      }
    }
  }

  &.error {
    .react-datepicker-wrapper {
      input {
        color: ${COLOR_RED};
        border-color: ${COLOR_RED};
        &:focus,
        &:hover {
          border: 1px solid ${COLOR_RED};
          outline: none;
          box-shadow: none;
          border-color: ${COLOR_RED};
        }
      }
    }
  }
`;
